import { connect } from 'react-redux';

import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ChannelTypes } from '../types/ChannelTypes';
import { ContentInfoCardChannel, ContentInfoChannelOwnProps, ContentInfoChannelProps } from './ContentInfoCardChannel';

export const ConnectedFavoritesChannel = connect((state: AppState, props: ContentInfoChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(state);

  let list: IContentInfo[] = [];
  state.home.favorites.items.forEach((contentId: string) => {
    list.push(state.home.contentById[contentId]);
  });

  const favChannelProps: ContentInfoChannelProps = {
    channelType: ChannelTypes.favorites,
    title: Messages.home_favoritesTitle(),
    seeAllUrl: siteUrls.favoritesUrl(),
    seeAllAltText: Messages.home_favorites_alt_seeAll(),
    list,
    isFetching: state.home.favorites.isFetching,
    numRows: 2,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state)
  };

  return favChannelProps;
})(ContentInfoCardChannel);
